export const COLEN: string = ":";
export type CreditorInfo = {
  creditorColor: string;
};
